import React, { Fragment } from "react";
import {
  makeStyles,
  Container,
  Typography,
  Box,
  Link,
} from "@material-ui/core";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";
import { useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "black",
    color: theme.palette.primary.main,
    maxWidth: "1800px",
    minHeight: "100vh",
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(8),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(6),
      minHeight: "auto",
    },
    [theme.breakpoints.down(450)]: {
      marginTop: theme.spacing(5),
      height: "auto",
    },
  },
  mainCompanyWrapper: {
    width: "60%",
    textAlign: "center",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      width: "80%", 
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%", 
    },
  },
  heading: {
    color: theme.palette.primary.main,
    fontSize: "32px",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px",
    },
  },
  description: {
    color: theme.palette.primary.main,
    textAlign: "justify",
    fontSize: "18px",
    fontWeight: 300,
    [theme.breakpoints.down("xs")]: {
      fontSize: "15px",
    },
  },
  specialDescription: {
    backgroundColor: theme.palette.primary.main,
    color: "black",
    textAlign: "justify",
    fontSize: "13px",
    fontWeight: 400,
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(8),
  },
  footer: {
    marginTop: theme.spacing(16),
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  footerLink: {
    margin: "0 10px",
    color: theme.palette.primary.main,
    textDecoration: "none",
    cursor: "pointer", // Adding pointer cursor
  },
}));

function BooksCatalog() {
  const theme = useTheme();
  const classes = useStyles();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Container className={classes.root} style={{ width: "100%" }}>
      <Container className={classes.mainCompanyWrapper}>
        <Typography variant="p" className={classes.heading} align="center">
          KleverBook Ad Pricing Schedule
        </Typography>

        <Box marginTop={4}>
          <Typography
            variant="body1"
            className={classes.description}
            style={{ textDecoration: "underline" }}
            align="center"
          >
            Retail Value of Publication: $500.00 and Above*
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            style={{ marginTop: "16px" }}
            align="center"
          >
            > eksplode! Retailers Only (Retailers who maintain product catalogs
            with eksplode!)
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 1: Open (bid for placement—minimum bid of $10.00 required)
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 2: $7.50
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 3: $6.00
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 4: $5.00
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 5: $4.00
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 6: FREE
          </Typography>
        </Box>
        <Box marginTop={4}>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            > Industry Brands (Unaffiliated with eksplode!)
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 1: Open (bid for placement—minimum bid of $12.00 required)
          </Typography>
        </Box>
        <Box marginTop={4}>
          <Typography
            variant="body1"
            className={classes.description}
            style={{ textDecoration: "underline" }}
            align="center"
          >
            Retail Value of Publication: $100.01 > $500.00
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            style={{ marginTop: "16px" }}
            align="center"
          >
            > eksplode! Retailers Only—Retailers who maintain product catalogs
            with eksplode!
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 1: Open (bid for placement—minimum bid of $7.50 required)
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 2: $5.00
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 3: $4.00
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 4: $3.00
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 5: $2.50
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 6: FREE
          </Typography>
        </Box>
        <Box marginTop={4}>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            > Industry Brands (Unaffiliated with eksplode!)
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 1: Open (bid for placement—minimum bid of $9.00 required)
          </Typography>
        </Box>
        <Box marginTop={4}>
          <Typography
            variant="body1"
            className={classes.description}
            style={{ textDecoration: "underline" }}
            align="center"
          >
            Retail Value of Publication: $50.01 > $100.00
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            style={{ marginTop: "16px" }}
            align="center"
          >
            > eksplode! Retailers Only—Retailers who maintain product catalogs
            with eksplode!
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 1: Open (bid for placement—minimum bid of $5.00 required)
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 2: $3.00
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 3: $2.00
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 4: $1.00
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 5: $0.50
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 6: FREE
          </Typography>
        </Box>
        <Box marginTop={4}>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            > Industry Brands (Unaffiliated with eksplode!)
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 1: Open (bid for placement—minimum bid of $6.00 required)
          </Typography>
        </Box>
        <Box marginTop={4}>
          <Typography
            variant="body1"
            className={classes.description}
            style={{ textDecoration: "underline" }}
            align="center"
          >
            Retail Value of Publication: $50.00 or less
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            style={{ marginTop: "16px" }}
            align="center"
          >
            > eksplode! Retailers Only—Retailers who maintain product catalogs
            with eksplode!
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 1: Open (bid for placement—minimum bid of $2.00 required)
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 2: $1.00
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 3: $0.50
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 4: $0.25
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 5: $0.10
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 6: FREE
          </Typography>
        </Box>
        <Box marginTop={4}>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            > Industry Brands (Unaffiliated with eksplode!)
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Level 1: Open (bid for placement—minimum bid of $3.00 required)
          </Typography>
        </Box>
        <Box marginTop={4}>
          <Typography
            variant="body1"
            className={classes.description}
            style={{ textDecoration: "underline" }}
            align="center"
          >
            Side Notes
          </Typography>
          <ul style={{ paddingLeft: "20px" }}>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="justify"
                style={{ marginTop: "16px" }}
              >
                The “Ad Level” number indicates the level of priority given to
                each Chapter Ad. For example, Level 1 Ads will be placed before
                Level 2 Ads, Level 2 Ads will be placed before Level 3 Ads, and
                so on.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="justify"
                style={{ marginTop: "16px" }}
              >
                Level 1 Chapter Ads will receive priority placement according to
                the amount a Retailer/Brand bids. In other words, the Ad with
                the highest bid will be placed at the beginning of the next
                KleverBook selected for download.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="justify"
                style={{ marginTop: "16px" }}
              >
                Level 1 Chapter Ads of the same Level Value** (or bid amount)
                will be placed in the order received, according to time and
                date.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="justify"
                style={{ marginTop: "16px" }}
              >
                Ad payments are automatically charged once a reader downloads
                the KleverBook (which is when the Ads are inserted). Free
                Chapter Ads will be placed when and where space is available and
                in the order they are logged into our system.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="justify"
                style={{ marginTop: "16px" }}
              >
                Chapter Ads will not be placed if books are not downloaded. In
                other words, there is no guarantee of Ad placement.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="justify"
                style={{ marginTop: "16px" }}
              >
                Prices are for one-week placements; i.e., Ads expire one week
                from when they were placed.
              </Typography>
            </li>
          </ul>
        </Box>
        <Box marginTop={4}>
          <hr
            style={{
              marginTop: "16px",
              borderColor: theme.palette.primary.main,
            }}
          />
          <Typography
            variant="body1"
            className={classes.description}
            align="justify"
            style={{ marginTop: "16px" }}
          >
            * The Retail Value means the average retail price the book sells
            for.
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="justify"
            style={{ marginTop: "16px" }}
          >
            ** Level Value defined: ekspIode!’s Ad Pricing Schedule allows
            Retailers and Brands to select the amount they are willing to spend
            per Ad, according to the Level chosen (or bid amount), which
            correspondingly determines Ad placement in each KleverBook
            downloaded.
          </Typography>
        </Box>
      </Container>
      <Container className={classes.footer}>
        <Link
          onClick={scrollToTop}
          style={{ textDecoration: "none" }}
          className={classes.footerLink}
        >
          Top
        </Link>
        <NavLink to="/" className={classes.footerLink}>
          Home
        </NavLink>
      </Container>
    </Container>
  );
}

export default BooksCatalog;
